import React, { useEffect, useState } from "react";
import { checkPassword } from "helper/helper";
import {
  Information,
  InterrogationCercle,
  ValidationCercle,
  NoShowPassword,
  ShowPassword,
} from "assets/icons";

const LandingPassword = ({ userData, setUserData, setValidFormPassword }) => {
  const [validMatch, setValidMatch] = useState(false);
  const [lower, setLower] = useState(false);
  const [upper, setUpper] = useState(false);
  const [number, setNumber] = useState(false);
  const [special, setSpecial] = useState(false);
  const [length, setLength] = useState(false);
  const [valid, setValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);

  const handleCheck = () => {
    const result = checkPassword(userData.password);
    setLower(result.lower);
    setNumber(result.number);
    setLength(result.length);
    setUpper(result.upper);
    setSpecial(result.special);
  };

  useEffect(() => {
    setValidMatch(userData.password === userData.confirmPassword);
  }, [userData.password, userData.confirmPassword]);

  useEffect(() => {
    handleCheck();
  }, [userData.password]);

  useEffect(() => {
    if (length && special && number && upper && lower) setValid(true);
    else setValid(false);
  }, [length, special, number, upper, lower]);

  useEffect(() => {
    setValidFormPassword(
      valid &&
        validMatch &&
        userData.password.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z0-9\S]{8,40}$/
        )
    );
  }, [valid, validMatch, userData.password, setValidFormPassword]);

  return (
    <div className="rounded-md shadow-sm -space-y-px">
      <div className="grid grid-cols-12 gap-3">
        <div className="col-span-12">
          <label className="block">
            <div className="ft-sm font-medium text-gray-500">
              Mot de passe <span className="text-red-500">*</span>
            </div>
            <div className="relative text-gray-500">
              <input
                name="password"
                value={userData.password}
                onChange={(e) =>
                  setUserData({ ...userData, password: e.target.value })
                }
                onKeyUp={handleCheck}
                className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg"
                type={showPassword ? "text" : "password"}
                required
              />
              <div
                className="absolute inset-y-0 right-0 flex items-center px-2 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <NoShowPassword wh={18} color="#666666" strokeW={2} />
                ) : (
                  <ShowPassword wh={18} color="#666666" strokeW={2} />
                )}
              </div>
            </div>
          </label>
          {userData.password !== "" && (
            <div className="bg-gray-100 p-2 sh-sm mt-3 rounded-md">
              <p
                className={`flex flex-row justify-start items-center gap-3 ${
                  valid ? "text-green-600" : "text-yellow-600"
                }`}
              >
                <span>
                  {valid ? (
                    <Information wh={20} color="#059669" />
                  ) : (
                    <Information wh={20} color="#FF9600" />
                  )}
                </span>
                Votre mot de passe doit contenir :
              </p>
              <ul className="relative flex flex-col gap-3 mt-2">
                {[
                  { ok: length, label: "Au moins 8 caractères" },
                  { ok: upper, label: "Au moins un caractère majuscule" },
                  { ok: lower, label: "Au moins un caractère minuscule" },
                  { ok: special, label: "Au moins un caractère spécial" },
                  { ok: number, label: "Au moins un chiffre (0-9)" },
                ].map(({ ok, label }) => (
                  <li
                    key={label}
                    className={`${
                      ok ? "text-gray-300" : ""
                    } relative flex flex-row items-center list-none transition-all ft-sm gap-3`}
                  >
                    {ok ? (
                      <ValidationCercle wh={20} color="#059669" />
                    ) : (
                      <InterrogationCercle wh={20} color="#DC2626" />
                    )}
                    {label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="col-span-12">
          <label className="block">
            <div className="ft-sm font-medium text-gray-500">
              Confirmation mot de passe <span className="text-red-500">*</span>
            </div>
            <div className="relative">
              <input
                name="confirmPassword"
                onChange={(e) =>
                  setUserData({ ...userData, confirmPassword: e.target.value })
                }
                value={userData.confirmPassword}
                className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg focus:shadow-outline"
                type={confirmShowPassword ? "text" : "password"}
                required
              />
              <div
                className="absolute inset-y-0 right-0 flex items-center px-2 cursor-pointer"
                onClick={() => setConfirmShowPassword(!confirmShowPassword)}
              >
                {confirmShowPassword ? (
                  <NoShowPassword wh={18} color="#666666" strokeW={2} />
                ) : (
                  <ShowPassword wh={18} color="#666666" strokeW={2} />
                )}
              </div>
            </div>
          </label>
          <p
            className={
              userData.confirmPassword && !validMatch
                ? "text-red-500 flex flex-row gap-4 items-center m-2"
                : "hidden"
            }
          >
            <span>
              <Information wh={15} color="#FF9600" />
            </span>
            Vos mots de passe ne correspondent pas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingPassword;
